import { FC } from 'react';

import { Box, Dialog, IconButton, Typography } from '@mui/material';

import AspectRatio, { AspectRatioWrapper } from 'components/common/AspectRatio';
import CountdownTimer from 'components/common/CountdownTimer';

import CloseIcon from 'components/common/svg/close';

import { IPromotion } from 'api/website';
import useSelectedTheme from 'store/theme';
import useScreen from 'hooks/useScreen';

interface PromotionDetailsDialogProps {
  open: boolean;
  onClose: () => void;
  promotion: IPromotion;
}

const PromotionDetailsDialog: FC<PromotionDetailsDialogProps> = ({ open, promotion, onClose }) => {
  const { isMobile } = useScreen();
  const [{ isDark }] = useSelectedTheme();

  const downtime = promotion.end_date && promotion.show_downtime;

  return (
    <Dialog
      keepMounted
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          maxWidth: '80vw',
          minHeight: '60vh',
          bgcolor: 'background.paper',
          overflowY: 'unset',
          position: 'relative',
          pb: 5,
        },
      }}
    >
      <Box sx={{ position: 'absolute', right: 20, top: 20, zIndex: 100 }}>
        <IconButton onClick={onClose} data-testid="dialog-close-btn">
          <CloseIcon />
        </IconButton>
      </Box>
      <Box className="content-m" sx={{ position: 'relative' }}>
        <Box sx={{ mx: 'auto', width: downtime ? '85%' : '95%', marginTop: isMobile ? '-5vh' : '-15vh', mb: 3 }}>
          <AspectRatioWrapper>
            <AspectRatio widthPercent={6}>
              <Box
                sx={{
                  width: '100%',
                  textAlign: 'center',
                  height: '100%',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  backgroundImage: `url(${isDark ? promotion.img_dark : promotion.img})`,
                }}
                title={promotion.title}
                data-testid="promotion-image"
              />
            </AspectRatio>
          </AspectRatioWrapper>
        </Box>
        <Typography fontSize={28} mb={2} data-testid="promotion-title">
          {promotion.title}
        </Typography>
        {downtime && <CountdownTimer targetDate={promotion.end_date} data-testid="promotion-countdown" />}
        <Box sx={{ maxHeight: downtime ? '35vh' : '40vh', overflow: 'auto' }}>
          <Typography
            dangerouslySetInnerHTML={{ __html: promotion?.description?.replace(/(?:\r\n|\r|\n)/g, '<br>') }}
            data-testid="promotion-description"
          />
        </Box>
      </Box>
    </Dialog>
  );
};

export default PromotionDetailsDialog;
